import React from 'react';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { OtpInputComponent } from '@syncfusion/ej2-react-inputs';

type Props = {
  visible: boolean;
  onClose: () => void | Promise<void>;
  tokenValue: string;
  setTokenValue: (v: string) => void;
  onFinish: () => void | Promise<void>;
};

const TokenDialog: React.FC<Props> = ({ visible, onClose, tokenValue, setTokenValue, onFinish }) => {
  const isDisabled = !tokenValue;
  return (
    <DialogComponent
      visible={visible}
      width="400px"
      isModal
      showCloseIcon
      header="Bestätigungscode"
      close={onClose}
      buttons={[
        {
          buttonModel: { content: 'Fertigstellen', disabled: isDisabled, cssClass: 'e-custom modal-dialog-btn' },
          click: onFinish,
        },
      ]}
    >
      <div style={{ padding: 16 }}>
        <OtpInputComponent value={tokenValue} input={(e: any) => setTokenValue(e.value)} length={6} type="text" />
        <p style={{ marginTop: 8, fontSize: '0.9rem', color: '#555' }}>
          Der Code wurde an die angegebene E-Mail gesendet.
        </p>
      </div>
    </DialogComponent>
  );
};

export default TokenDialog;
